(() => {
  const SELECTOR = '.quantity-selector--tissu';

  function formatMetres(quantity) {
    const metres = quantity * 0.5;

    if (Number.isInteger(metres)) {
      return `${metres} m`;
    }

    return `${metres.toFixed(1).replace('.', ',')} m`;
  }

  function updateSelector(selector) {
    if (!selector) return;

    const input = selector.querySelector(
      'input[name="quantity"], input[name="updates[]"]'
    );

    const display = selector.querySelector(
      '.quantity-selector__meter-display'
    );

    if (!input || !display) return;

    const quantity = Math.max(
      1,
      Number.parseInt(input.value, 10) || 1
    );

    const metres = formatMetres(quantity);

    display.textContent = metres;
    input.setAttribute(
      'aria-label',
      `Métrage sélectionné : ${metres}`
    );
  }

  function updateAllSelectors() {
    document.querySelectorAll(SELECTOR).forEach(updateSelector);
  }

  document.addEventListener('input', (event) => {
    const selector = event.target.closest(SELECTOR);

    if (selector) {
      updateSelector(selector);
    }
  });

  document.addEventListener('change', (event) => {
    const selector = event.target.closest(SELECTOR);

    if (selector) {
      updateSelector(selector);
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      `${SELECTOR} button[name="minus"], ${SELECTOR} button[name="plus"]`
    );

    if (!button) return;

    const selector = button.closest(SELECTOR);

    window.requestAnimationFrame(() => {
      updateSelector(selector);
    });

    window.setTimeout(() => {
      updateSelector(selector);
    }, 100);
  });

  document.addEventListener('shopify:section:load', updateAllSelectors);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllSelectors);
  } else {
    updateAllSelectors();
  }
})();